import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import placeholderImageUrl from './assets/placeholder.svg'

interface ItemProps {
  callbacks: {
    action: (arg?: any) => void,
  },
  imageProps?: object,
  imageUrl: string,
  secondaryTitle: string,
  title: string,
}

const ListItemImageCover = (props: ItemProps) => {
  const {
    callbacks: { action },
    imageProps,
    imageUrl,
    secondaryTitle,
    title,
  } = props

  return (
    <Box
      flexDirection="column"
      height="fit-content"
      onClick={() => action()}
      style={{ cursor: 'pointer' }}
      variant="white"
    >
      <Image
        backgroundSize="cover"
        borderRadius="5px 5px 0 0"
        boxProps={{ backgroundColor: 'backgroundColor' }}
        height={220}
        placeholderUrl={placeholderImageUrl}
        url={imageUrl}
        {...imageProps}
      />

      <ListItem
        boxProps={{
          borderBottom: '1px dashed', borderTop: '1px solid', padding: 'large',
        }}
        showAngleIcon
      >
        <Box flexDirection="column" paddingRight="medium">
          <Text fontSize="small" variant="ellipsis">{title}</Text>

          <Text fontSize="xsmall" color="mysteryGrey" marginTop="small">{secondaryTitle}</Text>
        </Box>
      </ListItem>
    </Box>
  )
}

export default ListItemImageCover
